module.exports = __webpack_public_path__ + "static/media/plus_ip.db7eca6f.svg";